import styled from 'styled-components';

export const BannerImageWrapper = styled.div`
  overflow: hidden;
  margin-bottom: 10px;
`;

export const BannerImage = styled.img`
  display: block;
  max-height: 300px;
  width: 100%;
  object-fit: cover;
  vertical-align: top;
`;
